/**
 * Eli Beauty Luxury Theme - Main JavaScript
 * Version: 1.0.0
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initMobileMenu();
    initScrollEffects();
    initCartCount();
  }

  /**
   * Mobile Menu Toggle
   */
  function initMobileMenu() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileNav = document.querySelector('.mobile-nav');
    const menuIcon = document.querySelector('.menu-icon');
    const closeIcon = document.querySelector('.close-icon');

    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', function() {
        const isOpen = mobileNav.style.display !== 'none';
        
        if (isOpen) {
          mobileNav.style.display = 'none';
          if (menuIcon) menuIcon.style.display = 'block';
          if (closeIcon) closeIcon.style.display = 'none';
        } else {
          mobileNav.style.display = 'block';
          if (menuIcon) menuIcon.style.display = 'none';
          if (closeIcon) closeIcon.style.display = 'block';
        }
      });

      // Close mobile menu when clicking on a link
      const mobileLinks = mobileNav.querySelectorAll('a');
      mobileLinks.forEach(link => {
        link.addEventListener('click', function() {
          mobileNav.style.display = 'none';
          if (menuIcon) menuIcon.style.display = 'block';
          if (closeIcon) closeIcon.style.display = 'none';
        });
      });
    }
  }

  /**
   * Scroll Effects for Header
   */
  function initScrollEffects() {
    const header = document.querySelector('.site-header');
    
    if (header) {
      let lastScroll = 0;
      
      window.addEventListener('scroll', function() {
        const currentScroll = window.pageYOffset;
        
        // Add shadow when scrolled
        if (currentScroll > 50) {
          header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.05)';
        } else {
          header.style.boxShadow = 'none';
        }
        
        lastScroll = currentScroll;
      });
    }
  }

  /**
   * Update Cart Count
   */
  function initCartCount() {
    // This function can be extended to update cart count dynamically
    // For now, it's a placeholder for future cart functionality
    
    document.addEventListener('cart:updated', function(event) {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount && event.detail && event.detail.item_count !== undefined) {
        cartCount.textContent = event.detail.item_count;
        cartCount.style.display = event.detail.item_count > 0 ? 'block' : 'none';
      }
    });
  }

  /**
   * Smooth Scroll for Anchor Links
   */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href !== '#!') {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  /**
   * Lazy Load Images (if not using native lazy loading)
   */
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }

})();
